import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_FOUNDERS_START, PUT_FOUNDERS_ERROR, PUT_FOUNDERS_START, PUT_FOUNDERS_SUCCESS } from '../../types';

import apiCall from '../../../api';

export function* edit({ payload }) {
  try {
    const url = `/founders/update/${payload.id}`;
    const method = 'PUT';
    const data = payload.data;
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, data, headers);
    console.log(results)
    yield put({ type: PUT_FOUNDERS_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: PUT_FOUNDERS_ERROR, error });
  } finally {
    yield put({ type: GET_FOUNDERS_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* put_founders() {
  yield takeLatest(PUT_FOUNDERS_START, edit);
}

